import { inkTokens } from '@ds/tokens'

const NUM_COLORS = 10

/**
 * Returns a color object with background and text color, often used to provide
 * a repeating sequence of colors to apply to recipients.
 * @param {number} index - A zero-based index. Defaults to 0
 * @returns {Object} colorIndexStyles - An object containing CSS styles for background and color properties.
 * @returns {string} colorIndexStyles.backgroundColor - The background color for the recipient.
 * @returns {string} colorIndexcolorIndexStyles.color - The text color for the recipient.
 * @example
 * const indexedColor = getColorIndex(1)
 *  <div css={{ backgroundColor: indexedColor.backgroundColor, color: indexedColor.color}} />
 */
export function getColorIndex(index = 0) {
  const normalizedIndex = Math.max(0, index % NUM_COLORS)

  const recipientBackgroundColors = [
    inkTokens.light.recipientBgColor100,
    inkTokens.light.recipientBgColor200,
    inkTokens.light.recipientBgColor300,
    inkTokens.light.recipientBgColor400,
    inkTokens.light.recipientBgColor500,
    inkTokens.light.recipientBgColor150,
    inkTokens.light.recipientBgColor250,
    inkTokens.light.recipientBgColor350,
    inkTokens.light.recipientBgColor450,
    inkTokens.light.recipientBgColor550,
  ] as const

  const recipientTextColors = [
    inkTokens.light.recipientFontColor100,
    inkTokens.light.recipientFontColor200,
    inkTokens.light.recipientFontColor300,
    inkTokens.light.recipientFontColor400,
    inkTokens.light.recipientFontColor500,
    inkTokens.light.recipientFontColor150,
    inkTokens.light.recipientFontColor250,
    inkTokens.light.recipientFontColor350,
    inkTokens.light.recipientFontColor450,
    inkTokens.light.recipientFontColor550,
  ] as const

  const colorIndexStyles =
    // index -1, is reserved for the sign recipient colors.
    index === -1
      ? {
          backgroundColor: inkTokens.light.recipientBgColorSign,
          color: inkTokens.light.recipientFontColorSign,
        }
      : {
          backgroundColor: recipientBackgroundColors[normalizedIndex],
          color: recipientTextColors[normalizedIndex],
        }

  return colorIndexStyles
}
